/**
 *
 * We also keep "intersection observer" polyfill as its currently only supported on 45% of devices in germany (neither IE nor safari and iOS).
 * This should be changed once the metrics change.
 */

// intersection observer
// @ts-ignore
require('intersection-observer')
/**
 * Polyfills Scroll Behavior specification
 */
require('smoothscroll-polyfill').polyfill()

require('abortcontroller-polyfill/dist/polyfill-patch-fetch')

/**
 * enable smoothscroll polyfill : https://github.com/iamdustan/smoothscroll#force-polyfill-implementation
 */
window.__forceSmoothScrollPolyfill__ = true
